var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#01BF11;}\n\t.st1{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#EF6B5B;stroke:#EF6B5B;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 270,
  cy: 271,
  r: 262
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M421.78,180.32c0,0,0-33.55-33.55-33.55s-33.55,33.55-33.55,33.55"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M200,180.91c0,0,0-33.55-33.55-33.55s-33.55,33.55-33.55,33.55"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M263.64,298.9c-66.46,0-58.15-74.77-58.15-74.77c66.46-33.23,132.92,0,132.92,0S346.71,298.9,263.64,298.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M319.96,279.28c-36.32-18.43-73.49-7.44-97.29,4.19c8.72,9,21.61,15.43,40.97,15.43 C291.47,298.9,308.89,290.44,319.96,279.28z"
})));

function SvgMood5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood5);
export default __webpack_public_path__ + "static/media/mood5.03d50d55b7b630d959942f3d4f5c9060.svg";
export { ForwardRef as ReactComponent };